import CryptoJS from 'crypto-js';

const jwtEndString =
  '.GuW9Lwy7fcK7PFOApARYzaURSo23DMqeDWcADazCVfhvf4VIYrFJ_bifunxkq_4l2QLOczQr0LrOChX-hpvT_5kdTFO5ogeXWA4lCSCLlM1UFA1iVgEliqzzy26odlAs51-EC5QVjhBzkXoTf7zX5LuJBZ_LAY6fKZCMl86tlOTnr0gDjjlZQNzOJ0EF0YDafFT0jV3AdVQtFTKVRsDUeunK2EjY6WJAL9pYNOJB06mX7w7c1OZCrWlnbEVtn3smIc3Vs7V55EQ8MqMKP19uGN_GStfejebNJbX1WPqC0VQeTUccdWdmwy_BDKnWUnMaNkufsRM0qCHS_CJt5NToZA';

export const base64url = (source) => {
  let encodedSource = CryptoJS.enc.Base64.stringify(source);
  encodedSource = encodedSource.replace(/=+$/, '');
  encodedSource = encodedSource.replace(/\+/g, '-');
  encodedSource = encodedSource.replace(/\//g, '_');
  return encodedSource;
};

export const createJWT = (header, data, secret = undefined) => {
  const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  const encodedHeader = base64url(stringifiedHeader);
  const stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  const encodedData = base64url(stringifiedData);
  const token = encodedHeader + '.' + encodedData;
  if (!secret) return token;
  let signature = CryptoJS.HmacSHA256(token, secret);
  signature = base64url(signature);
  return encodedHeader + '.' + encodedData + '.' + signature;
};

export const createJWTbackendToken = (
  tennant: string,
  user: string,
  userId: string
) => {
  const header = {
    alg: 'RS256',
    typ: 'JWT',
    //kid: property is the only one that changes after a cetain period of time,
    //when it changes, to run the app locally you will have to set the new one
    //you can get it from the token on staging after decoding or in the azureportal
    kid: 'XRvko8P7A3UaWSnU7bM9nT0MjhA',
  };
  const data = {
    aud: 'a8a02cb6-9df3-4cd8-837c-a855c14ec132',
    iss: `https://login.microsoftonline.com/${tennant}/v2.0`,
    oid: userId,
    preferred_username: user,
    scp: 'access_as_user',
    tid: tennant,
  };
  return createJWT(header, data) + jwtEndString;
};
